const params = new URLSearchParams(location.search)

export const appVersion = params.get('app_version')

export const language = params.get('language') ?? 'en'

export type Platform = 'ios' | 'googleplay_android' | 'china_android'

export const platform = params.get('platform') as Platform

export const shouldMockAPI = params.has('mock')
